import { gql } from "@apollo/client"

const UPDATE_GROUP_MUTATION = gql`
  mutation($input: UpdateGroupInput!) {
    updateGroup(input: $input) {
      id
      title
      location {
        id
        name
      }
    }
  }
`

export { UPDATE_GROUP_MUTATION }
